import { ErrorsState } from './errors';
export { ErrorsState };

import { UserPreferences } from './user-preferences';
export { UserPreferences };

import { VenueProfile, VenueDetails, VenueService, VenuePackage } from '../types/venue-profile';
export { VenueProfile, VenueDetails, VenueService, VenuePackage };

import { VendorSignupData } from '../types/vendors';
export { VendorSignupData };

import { VenueManagementState } from '../components/venue-management/types';
export { VenueManagementState };

import { LandingPageState, BucketLandingPage, VenueDataItem } from './landingPages';
export { LandingPageState, BucketLandingPage, VenueDataItem };

import { AllStylesLandingPageData, StyleInfo } from './all-styles-landing-page';
export { AllStylesLandingPageData, StyleInfo };

import { MassInquiryPageData } from './mass-inquiry';
export { MassInquiryPageData };

import { SearchState } from './search';
export { SearchState };

export interface StoreState {
    errors: ErrorsState;
    venueProfile: VenueProfile;
    venueManagement: VenueManagementState;
    landingPageData: LandingPageState;
    barnVenue: BucketLandingPage;
    allStylesLandingPageData: AllStylesLandingPageData;
    massInquiryVenuesData: MassInquiryPageData;
}
